import React from 'react'

import {
  FollowDropdown,
  FollowDropdownAction,
  FollowDropdownBellIcon,
  FollowDropdownChevronIcon,
  FollowDropdownContent,
  FollowDropdownDescription,
  FollowDropdownDivider,
  FollowDropdownLabel,
  FollowDropdownTrigger,
} from './SubscriptionToggle.styles'

import { Status, ThreadToggleProps } from './types'

import { useUpdateNotification } from './operations'

//-----------------------------------------------------------------------------
// CONSTANTS

export const labels: Partial<{ [key in Status]: string }> = {
  ON: 'Following this thread',
  OFF: 'Not following this thread',
}

export const actions: Partial<{ [key in Status]: string }> = {
  ON: 'Follow this Thread',
  OFF: 'Stop Following this Thread',
}

export const descriptions: Partial<{ [key in Status]: string }> = {
  ON: 'You will receive notifications for this thread',
  OFF: 'You will not receive any notifications for this thread',
}

//-----------------------------------------------------------------------------
// COMPONENTS

export const ThreadSubscriptionToggle: React.FC<ThreadToggleProps> = ({
  status,
  id,
  documentVersionShortId,
  permanentArtboardShortId,
  shareIdentifier,
}) => {
  const { updateThreadNotification } = useUpdateNotification()

  const handleOn = () => {
    updateThreadNotification({
      id,
      status: 'ON',
      documentVersionShortId,
      permanentArtboardShortId,
      shareIdentifier,
    })
  }

  const handleOff = () => {
    updateThreadNotification({
      id,
      status: 'OFF',
      documentVersionShortId,
      permanentArtboardShortId,
      shareIdentifier,
    })
  }

  return (
    <>
      <FollowDropdown
        test-id="follow-dropdown"
        toggle={
          <FollowDropdownTrigger>
            <FollowDropdownBellIcon status={status} />
            <FollowDropdownLabel>{labels[status]}</FollowDropdownLabel>
            <FollowDropdownChevronIcon />
          </FollowDropdownTrigger>
        }>
        <FollowDropdownContent>
          <FollowDropdownDescription>
            {descriptions[status]}
          </FollowDropdownDescription>
          <FollowDropdownDivider />
          {status !== 'ON' && (
            <FollowDropdownAction onClick={handleOn}>
              {actions.ON}
            </FollowDropdownAction>
          )}
          {status !== 'OFF' && (
            <FollowDropdownAction onClick={handleOff}>
              {actions.OFF}
            </FollowDropdownAction>
          )}
        </FollowDropdownContent>
      </FollowDropdown>
    </>
  )
}
